import {FolderCreateDialogComponent} from './pages/folders/folder-create-dialog/folder-create-dialog.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './pages/login/login.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {MainComponent} from './pages/main/main.component';
import {UsersComponent} from './pages/users/users.component';
import {RolesComponent} from './pages/roles/roles.component';
import {FoldersComponent} from './pages/folders/folders.component';
import {UsersListComponent} from './pages/users/users-list/users-list.component';
import {RolesListComponent} from './pages/roles/roles-list/roles-list.component';
import {RolesFormComponent} from './pages/roles/roles-form/roles-form.component';
import {FormsModule} from '@angular/forms';
import {HttpInterceptorService} from './shared/services/http-interceptor.service';
import {UsersFormComponent} from './pages/users/users-form/users-form.component';
import {TrimPipe} from './shared/pipes/trim.pipe';
import {MioComponent} from './pages/mio/mio.component';
import {MioAccessDialogComponent} from './pages/mio/mio-access-dialog/mio-access-dialog.component';
import {EditUserComponent} from './pages/users/edit-user/edit-user.component';
import {DialogComponent} from './pages/users/edit-user/folders-list/dialog/dialog.component';
import {ReportsListComponent} from './pages/users/edit-user/reports-list/reports-list.component';
import {ReportDialogComponent} from './pages/users/edit-user/reports-list/report-dialog/report-dialog.component';
import {FoldersListComponent} from './pages/users/edit-user/folders-list/folders-list.component';
import {WidgetsListComponent} from './pages/users/edit-user/widgets-list/widgets-list.component';
import {AddWidgetDialogComponent} from './pages/components/add-widget-dialog/add-widget-dialog.component';
import {SelectUsersToShareComponent} from './pages/components/select-users-to-share/select-users-to-share.component';
import {materials} from './materials';
import { UsersFgjsComponent } from './pages/users-fgjs/users-fgjs.component';
import { UsersFgjsListComponent } from './pages/users-fgjs/users-fgjs-list/users-fgjs-list.component';
import { AddObjectComponent } from './pages/users-fgjs/add-object/add-object.component';
import { MatRadioButton } from '@angular/material/radio';
import { MatPaginator } from '@angular/material/paginator';
import { UsersDpmComponent } from './pages/users-dpm/users-dpm.component';
import { UsersDpmListComponent } from './pages/users-dpm/users-dpm-list/users-dpm-list.component';
import { AddObjectsComponent } from './pages/components/add-objects/add-objects.component';
import { MatCheckbox } from '@angular/material/checkbox';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MainComponent,
    UsersComponent,
    RolesComponent,
    FoldersComponent,
    UsersListComponent,
    RolesListComponent,
    RolesFormComponent,
    UsersFormComponent,
    TrimPipe,
    MioComponent,
    MioAccessDialogComponent,
    EditUserComponent,
    DialogComponent,
    ReportsListComponent,
    ReportDialogComponent,
    FoldersListComponent,
    FolderCreateDialogComponent,
    WidgetsListComponent,
    AddWidgetDialogComponent,
    SelectUsersToShareComponent,
    UsersFgjsComponent,
    UsersFgjsListComponent,
    AddObjectComponent,
    UsersDpmComponent,
    UsersDpmListComponent,
    AddObjectsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ...materials,
    MatRadioButton,
    MatPaginator,
    MatCheckbox
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
